import { render } from "./IconAirFilter.vue?vue&type=template&id=0009e6c4&lang=pug&bindings={\"id\":\"props\"}"
import script from "./IconAirFilter.vue?vue&type=script&lang=js"
export * from "./IconAirFilter.vue?vue&type=script&lang=js"
script.render = render

export default script